// extracted by mini-css-extract-plugin
module.exports = {"latestAssets":"AssetsLatest_latestAssets__vNKlk","title":"AssetsLatest_title__2ybQ_"};